<template>

  <b-card :id="`card-${id}`"  @click="fetchDetails(`${id}`)">
  <div>
    <div v-b-toggle="`collapse-${id}`" class="title">
      <div>
        <svg v-if="icon == 'email'" lns="http://www.w3.org/2000/svg" width="30" height="30" fill="#44A561" viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"></path></svg>

        <svg v-if="icon == 'phone'" xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="#44A561" viewBox="0 0 256 256"><path d="M144.27,45.93a8,8,0,0,1,9.8-5.66,86.22,86.22,0,0,1,61.66,61.66,8,8,0,0,1-5.66,9.8A8.23,8.23,0,0,1,208,112a8,8,0,0,1-7.73-5.94,70.35,70.35,0,0,0-50.33-50.33A8,8,0,0,1,144.27,45.93Zm-2.33,41.8c13.79,3.68,22.65,12.54,26.33,26.33A8,8,0,0,0,176,120a8.23,8.23,0,0,0,2.07-.27,8,8,0,0,0,5.66-9.8c-5.12-19.16-18.5-32.54-37.66-37.66a8,8,0,1,0-4.13,15.46Zm81.94,95.35A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"></path></svg>

        <svg v-if="icon == 'ip'" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#44A561" viewBox="0 0 256 256"><path d="M140,204a12,12,0,1,1-12-12A12,12,0,0,1,140,204Zm65-81.23a124,124,0,0,0-153.94,0A8,8,0,0,0,61,135.31a108,108,0,0,1,134.06,0,8,8,0,0,0,11.24-1.3A8,8,0,0,0,205,122.77Zm-32.26,35.76a76.05,76.05,0,0,0-89.42,0,8,8,0,0,0,9.42,12.94,60,60,0,0,1,70.58,0,8,8,0,1,0,9.42-12.94Z"></path></svg>

        <svg v-if="icon == 'visitor'" xmlns="http://www.w3.org/2000/svg" width="29" height="29" viewBox="0 0 34 34"><path fill="#44A561" d="M18 17a7 7 0 1 0-7-7a7 7 0 0 0 7 7m0-12a5 5 0 1 1-5 5a5 5 0 0 1 5-5" class="clr-i-outline clr-i-outline-path-1"/><path fill="#44A561" d="M30.47 24.37a17.16 17.16 0 0 0-24.93 0A2 2 0 0 0 5 25.74V31a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2v-5.26a2 2 0 0 0-.53-1.37M29 31H7v-5.27a15.17 15.17 0 0 1 22 0Z" class="clr-i-outline clr-i-outline-path-2"/><path fill="none" d="M0 0h36v36H0z"/></svg>
      </div>
      <div class="aling-text" style="display: flex; flex-direction: column; ">
        <h4 class="color-text">{{title}}</h4>
        <span v-if="icon =='email'">
        {{ analyse && analyse.client && analyse.client.email ? analyse.client.email : 'Email não encontrado' }}
        </span>
        <span v-if="icon == 'phone'">
        {{ analyse && analyse.client &&  analyse.client.cellphone ? analyse.client.cellphone : 'Cellphone não encontrado' }}
        </span>
        <span v-if="icon == 'ip'">
          {{  analyse  && analyse.payment_request && analyse.payment_request.ip ? analyse.payment_request.ip : 'Ip não encontrado'}}
        </span>
        <span v-if="icon == 'visitor'">
          {{   analyse && analyse.visitor && analyse.visitor.visitor_id ? analyse.visitor.visitor_id : 'Visitor não encontrado'}}
        </span>
      </div>
    </div>
     
  <div>
  <b-collapse v-show="!loading" :id="`collapse-${id}`" class="mt-2" >
      <div class="transactions-table">
      <table>
        <thead>
          <tr>
            <th>ID Pagarme</th>
            <th>ID Green</th>
            <th>Data</th>
            <th>Tipo</th>
            <th>Status</th>
            <th>Valor Green</th>
            <th>Método</th>
            <th>Antecipação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="analysis in data" :key="analysis.id">
            <td class="clique" @click="copyId(analysis.transaction_id)">{{ formatTransactionId(analysis.transaction_id)}}</td>
            <td class="clique" @click="copyId(analysis.id)">{{ analysis.id }}</td>
            <td>{{ formatDate(analysis.created_at) }}</td>
            <td>{{ analysis.type }}</td>
            <td ><p :class="{
              'paid': analysis.status === 'paid', 
              'rejected': analysis.status === 'refused', 
              'waiting': analysis.status === 'waiting_payment',
              'created': analysis.status === 'created',
              'refund_pending' : analysis.status === 'refund_pending',
              'chargedback': analysis.status === 'chargedback', 
              }">
              {{ translateStatus(analysis.status) }}
            </p></td>
            <td>{{ analysis.total | formatCurrency }}</td>
            <td><PaymentMethodIcon :method="analysis.method" /></td>
            <td>{{ analysis.fee | formatCurrency }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-collapse>

    <div v-show="loading" class="row justify-content-center">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
</div>
</div>
</b-card>


</template>

<script>
import AnalysisService from '@services/resources/AnalysisService';
const service = AnalysisService.build();

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    analyse: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      expandedIds: {},
      data: [],
      loading: false,
    };
  },
  methods: {
    formatTransactionId(id) {
      if (!id) return '---';
      if (this.expandedIds[id]) {
        return id;
      }
      return id.length > 10 ? `${id.substring(0, 10)}...` : id;
    },

    copyId(value) {
      const el = document.createElement('textarea')
      el.value = value
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)

      this.$bvToast.toast(
        `Item copiado com sucesso!`,
        {
          title: "Copiado!",
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        }
      );
    },
  
    async fetchDetails() {
      if(!this.type.length || this.data.length) {
        return;
      }

      this.loading = true;

      let data = {
        with: [this.type],
        url: this.$route.params.id + '/sale'
      }

      await service
        .search(data)
        .then((resp) => {
          if (resp.data && resp.data[this.type]) {
            this.data = resp.data[this.type];
          }
        }).finally(() => {
          this.loading = false;
        });
      // this.$emit('card-clicked', this.id);
    },

    formatDate(date) {
    let newDate = new Date(date);
    return newDate.toLocaleString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }).replace(',', ' às');
},

    translateStatus(status) {
    const statusMap = {
      'paid': 'Pago',
      'refused': 'Recusado',
      'waiting_payment': 'Aguardando pagamento',
      'created': 'Criado',
      'refund_pending': 'Reembolso Pendente',
      'chargedback': 'Reembolsado'
    };
    return statusMap[status] || status; 
   },

    paymentIcons(normalizedMethod) {
      let svgHtml = '';
      const tooltips = {
        'CREDIT_CARD': 'Cartão de Crédito',
        'PIX': 'Pix',
        'BOLETO': 'Boleto'
      };

      if(normalizedMethod === 'CREDIT_CARD') {
        svgHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000000" viewBox="0 0 256 256"><path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,16V88H32V64Zm0,128H32V104H224v88Zm-16-24a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h32A8,8,0,0,1,208,168Zm-64,0a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h16A8,8,0,0,1,144,168Z"></path></svg>`;
      } else if(normalizedMethod === 'PIX') {
        svgHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000000" viewBox="0 0 256 256"><path d="M235.34,116.72,139.28,20.66a16,16,0,0,0-22.56,0L20.66,116.72a16,16,0,0,0,0,22.56l96.06,96.06a16,16,0,0,0,22.56,0l96.06-96.06A16,16,0,0,0,235.34,116.72ZM128,32,184,88H160a8,8,0,0,0-5.66,2.34L128,116.68,101.66,90.34A8,8,0,0,0,96,88H72ZM56,104H92.68l24,24-24,24H56L32,128Zm72,120L72,168H96a8,8,0,0,0,5.66-2.34L128,139.31l26.34,26.35A8,8,0,0,0,160,168h24Zm72-72H163.32l-24-24,24-24H200l24,24Z"></path></svg>`;
      } else if(normalizedMethod === 'BOLETO') {
        svgHtml = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="#000000" viewBox="0 0 256 256"><path d="M72,104a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,104Zm8,40h96a8,8,0,0,0,0-16H80a8,8,0,0,0,0,16ZM232,56V208a8,8,0,0,1-11.58,7.15L192,200.94l-28.42,14.21a8,8,0,0,1-7.16,0L128,200.94,99.58,215.15a8,8,0,0,1-7.16,0L64,200.94,35.58,215.15A8,8,0,0,1,24,208V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V195.06l20.42-10.22a8,8,0,0,1,7.16,0L96,199.06l28.42-14.22a8,8,0,0,1,7.16,0L160,199.06l28.42-14.22a8,8,0,0,1,7.16,0L216,195.06Z"></path></svg>`;
      }

      return `<span v-b-tooltip.hover title="${tooltips[normalizedMethod] || ''}">${svgHtml}</span>`;
    }
  },
  filters: {
      formatCurrency(value) {
        if (!value) return 'R$ 0,00';
        value = Number(value);
        return value.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        });
      }
    }
};
</script>

<style scoped>
.transactions-table table {
  width: 100%;
  border-collapse: collapse;
}
.transactions-table th, .transactions-table td {
  padding: 8px;
  text-align: center;
  color: #141414;
  font-size: 14px;
  margin-bottom: 15px;
}
.transactions-table tr:not(:last-child) {
  border-bottom: 1px solid #ccc; 
}
.paid {
  margin: 0 auto;
  background-color: rgba(68, 165, 97, 0.1)!important;
  color: #44A561 !important;
  width: 60%;
  padding: 10px;
  border-radius: 20px;
}

.rejected {
  margin: 0 auto;
  background-color: rgba(255, 95, 95, 0.1) !important;
  color: #FF5F5F !important;
  padding: 10px;
  width: 60%;
  border-radius: 20px;
}

.waiting {
  margin: 0 auto;
  background-color: rgba(54, 130, 243, 0.1) !important;
  color: #3682F3 !important;
  padding: 10px;
  width: 65%;
  border-radius: 20px;
}

.created {
  margin: 0 auto;
  background-color: rgba(54, 215, 243, 0.1) !important;
  color: #00b3ff !important;
  padding: 10px;
  width: 65%;
  border-radius: 20px;
}

.refund_pending {
  margin: 0 auto;
  background-color: rgba(243, 133, 54, 0.1) !important;
  color: #df8d08 !important;
  padding: 10px;
  width: 65%;
  border-radius: 20px;
}

.chargedback {
  margin: 0 auto;
  background-color: rgba(89, 88, 88, 0.1) !important;
  color: #5d5959 !important;
  padding: 10px;
  width: 65%;
  border-radius: 20px;
}

.transactions-table table {
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0 10px; 

}

.transactions-table td {
  padding-top: 10px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc; 

}

.card{
  border: 1px solid #ccc; 
  border-radius: 10px;
}

.title{
  display: flex;
  align-items: baseline;
  gap: 15px;
}

.color-text {
  margin: 0px !important;
  color: #44A561;
}

.clique {
  cursor: pointer;
}
.aling-text{
  display: flex;
  flex-direction: column;
}
</style>
